export default "__VITE_ASSET__cd449f2c__"